import { supportedLocationTypes } from "@/components/directory/shared/constants";
import { GetLookupInfoRequest } from "@costar-search-x/core";
import { LocationSearchCriteria } from "../../../types";

const hasValue = (criteria: LocationSearchCriteria): boolean => {
  const { type, id } = criteria?.locationCriteria?.location?.geography ?? {};

  if (type && id) {
    return supportedLocationTypes.indexOf(Number(type)) >= 0;
  }
  return false;
};

const clearValue = (
  updateCriteria: (criteria: LocationSearchCriteria) => void
) => {
  updateCriteria({
    locationCriteria: {
      location: {
        geography: undefined,
      },
    },
  });
};

const render = () => <></>;

const getLookups = (
  criteria: LocationSearchCriteria
): GetLookupInfoRequest | undefined => {
  if (hasValue(criteria)) {
    const { type, id } = criteria?.locationCriteria?.location?.geography ?? {};

    if (type && id) {
      return {
        [type]: [id],
      };
    }
  }
};

export const sitesLocationFilter = {
  hasValue,
  clearValue,
  render,
  getLookups,
};
